<template>
    <div class="list-raovat pro-duct position-relative">
        <div class="fw-600 title-product-keyword">
            Thêm sản phẩm khuyễn mãi
            <div class="note">
                Tăng ngay doanh số bán hàng.
            </div>
        </div>
        <div class="search_input action-table-web position-relative">
           <label class="fw-600 fs-14px">1. Danh sách sản phẩm size color</label>
           <div class="box-size-color">
               <div class="sizeColor text-center" v-if="productSizeColor.length == 0">
                    Sản phẩm bạn chọn không có sản phẩm nào có màu sắc và kích thước
               </div>
               <div class="box">
                    <div class="name"  v-for="(item, key) in dataSizeColor" :key="key" v-html="item.fullname" @click="pushSale(item)"></div>
               </div>
            </div>
        </div>
        <label class="fw-600 fs-14px">2. Danh sách sản phẩm tham gia khuyễn mãi</label>
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <!-- thead web -->
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col" class="text-center">STT</th>
                    <th scope="col" class="text-center">Tên sản phẩm</th>
                    <th scope="col">Trạng thái KM</th>
                    <th scope="col">Giá hiện tại</th>
                    <th scope="col" class="text-center">Hình thức KM</th>
                    <th scope="col" class="text-center">Giá sau KM</th>
                    <th scope="col" class="text-center">Thời gian KM</th>
                    <th scope="col" class="text-center">Số lượng</th>
                    <th scope="col" class="text-center">Sửa</th>
                    <th scope="col" class="text-center">Xóa</th>

                </tr>
            </thead>
            <!-- hết thead web -->

            <!-- thead mobile -->
            <thead v-else>
                <tr>
                    <th scope="col" class="text-center py-1">
                       STT
                    </th>
                    <th scope="col" class="text-center py-1">Thông tin</th>
                </tr>
            </thead>
            <!-- hết thead mobile -->

            <!-- tbody -->

            <!-- check xem có dữliệu hay không -->
            <tbody v-if="product.length == 0">
                <tr>
                    <td colspan="8" class="text-center text-muted">Không có dữ liệu {{product.length}}</td>
                </tr>
            </tbody>

            <!-- có dữ liệu -->
            <!-- tbody web -->
            <tbody v-else-if="$detect == 'web'" class="product">
                <tr :class="{
                        'position-relative': true,
                    }" v-for="(item,index) in product" :key="index">
                    <!-- td checkbox -->
                    <td scope="row text-center" style="white-space: nowrap;">
                       {{ index + 1 }}
                    </td>
                    <!-- keyword -->
                    <td width="250" class="position-relative" v-html="item.name || item.fullname"></td>
                    <!-- td tiêu đề, id, link -->
                    <td class="hit-rv" width="100">
                        <div :class="{
                                'text-center' : true,
                                'status-waiting' : item.status_id == 0 || item.status_id == 1,
                                'status-success' : item.status_id == 2 || item.status_id == 4,
                                'status-danger'  : item.status_id > 4  || item.status_id == 3,
                            }">
                          {{ item.status }}
                        </div>
                    </td>
                    <!-- td lượt xem -->
                    <td class="price" width="100">
                        {{ $formatNumber(item.price_format) }}
                    </td>
                    <!-- hình thức khuyến mãi -->
                    <td width="140" class="text-center keyword-sale">
                        {{ $formatNumber(item.prp_value) }}<span v-if="item.type_reduce == 0">%</span><span v-else>₫</span>
                    </td>
                    <td width="120" class="text-center price">
                        {{ $formatNumber(item.price_promotion) }}
                    </td>
                    <td width="250" class="text-center">
                        <div class="fs-11px">{{item.date_start}} /  {{item.time_start}}    </div>
                        <div class="fs-13px">{{item.date_end}} /  {{item.time_end}}    </div>
                    </td>
                    <td width="70" :class="{
                                    'text-center' : true,
                                }">
                        {{ item.quantity ?  item.quantity : ''}}
                        <i v-if="!item.quantity" class="icon ion-ios-infinite"></i>
                    </td>
                    <td width="50" class="text-center position-relative" style="z-index: 99">
                        <button type="button" class="btn btn-warning btn-sm px-3"
                            @click="actionUpItem(item,'HappyLink')">
                            <i class="icon ion-md-create"></i>
                        </button>
                    </td>
                     <td width="50" class="text-center">
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destroy(item, index)">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <!-- hết tbody web -->

            <!-- tbody mobile -->
            <tbody v-else>
                <tr :class="{
                        'table-mobile position-relative': true,
                    }" v-for="(item, index) in product" :key="index">
                    <!-- td ảnh và checkbox -->
                    <td class="img-tab position-relative pl-1 text-center">
                       {{ index + 1 }}
                    </td>
                    <!-- td thông tin -->
                    <!-- click thông tin là show model xử lý -->
                    <!-- <td style="width: calc(100% - 100px)" @click="actionItem(item)"> -->
                    <td   class="position-relative"
                      @click="activeTr = index">
                        <div class="name fw-600">{{item.name}}</div>
                        <div :class="{
                                'end-start text-center' : true, 
                                'status'  : item.status == 1,
                                'waiting'  : item.status == 4
                                }">{{item.status_text}}</div>
                        <div class="price d-flex">
                            <div class="price-promotion fs-16px fw-600"> {{ $formatNumber(item.price_promotion) }}</div>
                            <div class="price-old fs-13px fw-600 ml-1"> {{ $formatNumber(item.price_format) }}</div>
                            <i class="icon ion-ios-arrow-round-down arow"></i>
                            <p class="discount fw-600">{{ $formatNumber(item.prp_value) }}</p>
                            <p v-if="item.type_reduce == 0" class="discount fw-600">%</p><p class="discount fw-600" v-else>₫</p>
                        </div>
                        <div class="d-block">
                            <span>SL :  {{ item.quantity ?  item.quantity : 8}}</span>
                            <span :class="{
                                'text-center' : true,
                                'float-right' : true,
                                'status-waiting' : item.status_id == 0 || item.status_id == 1,
                                'status-success' : item.status_id == 2 || item.status_id == 4,
                                'status-danger'  : item.status_id > 4  || item.status_id == 3,
                            }">
                          {{ item.status }}
                            </span>
                        </div>
                        <div class="time d-flex">
                            <i class="icon ion-md-time mr-1"></i>
                            <div class="fs-13px">{{item.date_start}} /  {{item.time_start}}</div> 
                            <i class="icon ion-ios-arrow-round-forward mr-1 ml-1"></i>
                            <div class="fs-13px">{{item.date_end}} /  {{item.time_end}}</div>
                        </div>
                      <!--   <div class="action-s">
                            <span>SL :  {{ item.quantity ?  item.quantity : 8}}</span>
                           
                            <button type="button" class="btn btn-danger btn-sm float-right"
                            @click="destroy(item)">
                                <i class="icon ion-md-trash"></i>
                            </button>
                             <button class="btn-edit btn-sm mr-1 btn ml-3 float-right" @click="detail(index,item)"><i class="icon ion-md-create"></i></button>
                        </div> -->
                        <div class="position-absolute actions-mobile" v-if="activeTr === index" :style="`width: ${widthTable}px`">
                            <div class="d-flex flex-wrap align-content-center justify-content-center" >
                                <div class="w-edit-delete" v-if="!(item.status == 1 && item.status_expire === 0)">
                                    <button class="border-0 text-white rounded-lg fs-14px btn-edit btn-success btn-block"
                                        @click="actionUpItem(item,'HappyLink')">
                                        <i class="icon ion-md-create"></i>
                                    </button>
                                </div>
                                <div class="w-edit-delete">
                                    <button class="border-0 text-white rounded-lg fs-14px btn-delete btn-danger btn-block"
                                        @click="destroy(item, index)">
                                        <i class="icon ion-md-trash"></i>
                                    </button>
                                </div>
                                <div class="w-100px w-edit-delete" >
                                    <a :href="$linkUrl(item.link)" target="_blank" class="btn w-100 border-0 text-primary rounded-lg fs-14px btn-detail bg-white">
                                        Xem chi tiết
                                    </a>
                                </div>
                                <div class="w-100px w-edit-delete">
                                    <button class="w-100 border-0 text-white text-dark rounded-lg fs-14px btn-cancel"
                                        @click="hiden()">
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <!-- hết tbody mobile -->
        </table>
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Tài khoản có:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{money.money_text}}</span> {{money.unit}}</span>
                <span class="ml-3"><a href="https://vatgia.com/nap-tien.html" class="btn-recharge">Nạp {{money.unit}}</a></span>
            </div>
        </div>
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Số tiền đã bị trừ:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{ $formatNumber(totalSpent) }}</span> {{money.unit}}</span>
            </div>
        </div>
        <div class="mt-5 mt-mobile d-flex product-keyword">
            <div class="btn-confirm mb-3">
                <button class="btn btn-primary mx-auto py-1" @click="submit">Cập nhật</button>
            </div>
        </div>
         <actionSale
            :action="action"
            :visible.sync="dialog"
            :data="itemaction"
            :dayNow="dayNow"
            :multiple="false"/>
        <transition name="slide-fade">
            <detailKeywordSale v-if="show" 
                    :data.sync="product[index]"
                    :arrPrice="arrPrice" 
                    :show.sync="show">
            </detailKeywordSale>
        </transition>
    </div>
</template>
<script>
import { upTop, availability, destroy } from '@/config/product';
export default {
    components: {
        actionSale: () => import('@/components/profile/product/actionSale.vue'),

        paginate: () => import('@/components/layout/pagination.vue'),
        actionTable: () => import('./fillter.vue'),
        detailKeywordSale: () => import('@/components/profile/product/detailKeywordSale.vue'),
    },
    data(){
        return {
            product: [], // data sản phẩm
            idSelect: [], // id rao vặt select để sử lý muti
             activeTr: '', // hiện tại k sử dụng (check lại)
            selectAll: false, // trạng thái có select all hay không
            loading: '', // loading theo tr
            loadingAction: '', // loading theo xử lý
            i : 0,
            auto: [],
            selectPrice : [],
            title: '',
            suggest : [],
            arrKey  : [],
            arrPrice : [],
            totalSpent : 0,
            keyword : '',
            timeOutStatus: null,
            id : this.$route.query.id,
            searchKeyword : [],
            showSuggest : false,
            dayNow : '',
            show : false,
            index: '',
            messageError : '',

            productSizeColor : [],
            dataSizeColor : [],
            dataSearch : [],
            dialog: false,
            itemaction: '',
            action: '',


        }
    },
    created() {
        this.$store.state.title = 'Tham gia khuyến mãi';
        let day = new Date();
        let dayNow = day.getDate() < 10 ? '0'+day.getDate() : day.getDate();
        let m = day.getMonth() + 1 < 10 ? '0'+(day.getMonth()+1) : day.getMonth() + 1;
        this.dayNow = day.getFullYear() + '-' + m + '-' + dayNow;
        this.getData();
        this.$removeOverflowHidenBody();
    },
    methods: {
        hiden(){
            setTimeout(() => {
                this.activeTr = '';
            }, 0)
        },
        actionUpItem(item, check){
            this.itemaction = item;
            this.action = check;
            this.dialog = true;
        },
        pushSale(item){
            let check = false;
            if(this.product.length > 0){
                this.product.map((val, index) => {
                    if(val.iPro == item.id){
                        check = true;
                    }
                })
            }
            if(!check || this.product.length == 0){
                this.product.push({
                    iPro : item.id,
                    prp_id : item.promotion.id,
                    type_reduce : item.promotion.prp_type_reduce == 0 ? item.promotion.prp_type_reduce : 1,
                    date_start : item.promotion.date_start ? item.promotion.date_start : this.dayNow,
                    date_end : item.promotion.date_end ? item.promotion.date_end : this.dayNow,
                    reduce_value : item.promotion.type_reduce ? item.promotion.type_reduce : -1,
                    prp_value   : item.promotion.prp_value ? item.promotion.prp_value : 0,
                    quantity : item.promotion.quantity ? item.promotion.quantity : 0,
                    estore_quantity : item.promotion.estore_quantity,
                    status : item.promotion.status != undefined  ? item.promotion.status : 'Chưa cài đặt',
                    status_id : item.promotion.status_id ? item.promotion.status_id : 0,
                    name : item.name,
                    time_start : item.promotion.time_start ? item.promotion.time_start : '08:00',
                    time_end : item.promotion.time_start ? item.promotion.time_start : '23:59',
                    estore_quantity : item.promotion.estore_quantity ? 1 : 0,
                    price  : item.price,
                    price_format : item.promotion.price_old ? item.promotion.price_old : item.price,
                    price_promotion : item.promotion.price_promotion ? item.promotion.price_promotion : item.price,
                    link    : item.link,
                });
            }
        },
        async getData(){
            await apiGet('/v2/products/get_product_promotion', {id : this.$route.query.id}).then(res => {
                this.dataSearch            = res.data.dataSearch;
                this.productSizeColor   = res.data.dataSizeColor;
                this.productSizeColor.map((item, index) => {
                    if(item == this.dataSearch[item].id){
                        this.dataSizeColor.push(this.dataSearch[item]);
                        delete this.dataSearch[item];
                    }
                })
                for (const [key, value] of Object.entries(this.dataSearch)) {
                    this.product.push({
                        iPro : value.id,
                        prp_id : value.promotion.id,
                        type_reduce : value.promotion.prp_type_reduce == 0 ? value.promotion.prp_type_reduce : 1,
                        date_start : value.promotion.date_start ? value.promotion.date_start : this.dayNow,
                        date_end : value.promotion.date_end ? value.promotion.date_end : this.dayNow,
                        reduce_value : value.promotion.type_reduce ? value.promotion.type_reduce : -1,
                        prp_value   : value.promotion.prp_value ? value.promotion.prp_value : 0,
                        quantity : value.promotion.quantity ? value.promotion.quantity : 0,
                        estore_quantity : value.promotion.estore_quantity,
                        status : value.promotion.status != undefined  ? value.promotion.status : 'Chưa cài đặt',
                        status_id : value.promotion.status_id ? value.promotion.status_id : 0,
                        name : value.name,
                        time_start : value.promotion.time_start ? value.promotion.time_start : '08:00',
                        time_end : '23:59',
                        estore_quantity : value.promotion.estore_quantity ? 1 : 0,
                        price  : value.price,
                        price_format : value.promotion.price_old ? value.promotion.price_old : value.price,
                        price_promotion : value.promotion.price_promotion ? value.promotion.price_promotion : value.price,
                        link : value.link,
                    });
                }
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'warning',
                        center: true,
                    });
                    this.$router.push({
                        name: 'product',
                        query: ''
                    })
                }
            });
        },
     
        async submit(){
            let form = [];
            let listID = [];
            this.messageError = "";
            this.product.map((item,index) => {
                form.push({
                    iPro        : item.iPro,
                    type_reduce        : item.type_reduce,
                    start_time  : item.time_start,
                    start_date  : item.date_start,
                    end_time    : item.time_end,
                    end_date    : item.date_end,
                    price       : item.price,
                    reduce_value  : item.prp_value,
                    quantity : item.quantity,
                    estore_quantity      : item.estore_quantity,
                });
                listID.push(item.iPro);
            })

            if(this.checkform()){
                await apiPost('/v2/products/add_promotion_product', {
                    form : form,
                    listId : listID
                }).then(res => {
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                    location.reload();
                }).catch(err => {
                    if(err.status == 410){
                        this.$message({
                            message: err.data.message,
                            type: 'warning',
                            center: true,
                        });
                    }
                });
            }else{
                this.$message({
                    message: this.messageError,
                    type: 'warning',
                    center: true,
                });
            }
        },
        checkform(){
            this.product.map((item,index) => {
                if(parseInt(this.dayNow.replace(/-/g,""),10) > parseInt(item.date_start.replace(/-/g,""),10)){
                    this.messageError += 'Sản phẩm "<span class="fw-600">' +item.name + '</span>": Thiết lập sai thời gian! </br>';
                }else{
                    if(parseInt(item.date_end.replace(/-/g,""),10) < parseInt(item.date_start.replace(/-/g,""),10)){
                        this.messageError += 'Sản phẩm "<span class="fw-600">' +item.name + '</span>": Thiết lập sai thời gian!</br>';
                    }
                }
                if(item.prp_value == 0){
                    this.messageError += 'Sản phẩm "<span class="fw-600">' +item.name + '</span>": Chưa chọn hình thức khuyến mãi!</br>';
                }
                if(item.price == 0){
                    this.messageError += 'Sản phẩm "<span class="fw-600">' +item.name + '</span>": Giá bằng 0 thì tham gia khuyến mãi kiểu gì!</br>';
                }
                if(item.estore_quantity == 0){
                    if(item.quantity == 0){
                        this.messageError += 'Sản phẩm "<span class="fw-600">' +item.name + '</span>": bạn chưa chọn số lượng!</br>';
                    }
                }
            })
            if(this.messageError == ''){
                return true;
            }
            return false;
        },
        destroy(item, key){
            this.$confirm('Bạn có chắc chắn xóa sản phẩm  "'+ item.name +'" trong chương trình khuyến mãi của vatgia.com ?', 'Xóa sản phẩm', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(async res => {
                if(item.prp_id != undefined){
                    await apiDelete('/v2/products/delete_promotion_product/'+ item.prp_id).then(res => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                            center: true,
                        });
                        this.getData();

                    }).catch(err => {
                        if(err.status == 410){
                            // this.error = err.data.message;
                            this.$message({
                                message: 'Thiết lập của bạn bị sai',
                                type: 'warning',
                                center: true,
                            });
                        }
                    });
                }
                this.product.splice(key, 1);
                

            }).catch(() => {})
        },
    },
    watch: {
        // query:{
        //     handler(val){
        //         apiGet('/v2/profile/products', {
        //             category: val.category ? val.category*1 : '',
        //             fillter: val.fillter ? val.fillter*1 : '',
        //             keyword: val.keyword,
        //             page: val.page ? val.page*1 : '',
        //         }).then(res => {
        //             this.preview = res.data.array_product_count;
        //             let data = res.data.db_listing;
        //             this.product = data.data;
        //             this.last_page = data.last_page;
        //             this.next_page = data.next_page;
        //             this.current_page = data.current_page;
        //             this.selectAll = false;
        //         });
        //     },
        //     deep: true
        // },
        // selectAll(val){
        //     this.idSelect = [];
        //     if(val){
        //         this.product.map(item => {
        //             this.idSelect.push(item.iKey);
        //         })
        //     }
        // },
        // idSelect: {
        //     handler(val){
        //         let count = 0;
        //         this.product.map(item => {
        //             if(item.status == 1 && item.status_expire == 1){
        //                 count += 1;
        //             }
        //         });
        //         if(val.length == count && count > 0){
        //             this.selectAll = true;
        //         }
        //     },
        //     deep: true,
        // },
        // showModel(val){
        //     if(!val){
        //         this.dataActionItem = {};
        //     }
        // }
    },
    computed: {
        widthTable(){
            let table = document.querySelector('table');
            return table.clientWidth;
        },
        query(){
            return this.$route.query;
        },
        money(){
            return this.$store.state.money;
        },
      
    },

}
</script>
<style lang='scss'>
    .keyword-sale{
        .date-change{
            height: 35px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #606266;
            outline: none;
            cursor: pointer;
            width: 135px;
        }   
        .ldc-time .ldc-dropdown input {
            width: 75px;
        }
        .set-width{
            width : 35px;
            line-height: 35px;
        }
        
    }
    .product-keyword{
        .btn-confirm{
            margin: 0 auto;
        }
    }
    .pro-duct{
        table{
            .table-mobile{
                .name{
                    max-height : 42px !important;
                    height : unset;
                }
            }
        }
    }
    .product {
        .rotext{
            transform : rotateZ(90deg);
        }
        .price{
            font-weight: 600;
            color: rgb(231, 76, 60);
        }
        .input-price-up{
            &.input-price-up-web{
                width: 60px !important;
            }
            border: none;
            border-bottom: 1px solid #000;
            width: 75px;
            border-radius: 0 !important;
            color: #dc3545;
            font-weight: 600;
        }
        .t_s{
            font-size: 10px; 
            left: 12px; 
            background: #f6f6f65c;
            color: red;
        }
        .status{
            color: green;
        }
        .waiting{
            color: #ffc107;
        }
        .auto-custom::before{
            left: -0.5rem;
        }
        .auto-custom::after{
            left: -0.5rem;
        }
        .status-waiting{
            color : #fd7e14;
        }
        .status-success{
            color : #28a745;
        }
        .status-danger{
            color : #dc3545;
        }

    }

    .table-mobile {
        .btn-edit{
            border: none;
            background: #f1c40f;
            padding: 0.313rem 0.5rem;
            font-size: .875rem;
            line-height: 1.5;
            border-radius: .2rem;
            i{
                color: white;
            }
        }
        .w-100px{
            width : 100px !important;
        }
         .status-waiting{
            color : #fd7e14;
        }
        .status-success{
            color : #28a745;
        }
        .status-danger{
            color : #dc3545;
        }
        .price{
            .price-promotion{
                color: #dc3545;
            }
            .price-old{
                text-decoration: line-through;
                color: #666;
                margin-top: 4px;
            }
            .arow{
                font-size: 20px;
                margin-top: -5px;
                margin-left: 5px;
                position: relative;
                color:red;
                animation-name: example;
                animation-duration: 0.5s;
                animation-iteration-count: infinite;
            }
            .discount{
                font-size : 12px;
                color: #dc3545;
            }
        }
        .name{
            max-height:42px!important;
        }
        .end-start{
            width: 36%;
            color: red;
            line-height: 42px;
            &.status{
                color: green;
            }
            &.waiting{
                color: #ffc107;
            }
        }
        .action-s{
            line-height: 42px;

        }
    }
    @-webkit-keyframes example {
      0% { left:0px; top:0px;}
      100% { left:0px; top:5px;}
    }
    .title-product-keyword{
        color: #333333;
        font-size: 18px;
        margin: 10px 0;
        border-bottom: 1px solid #d7d7d7;
        padding-bottom: 15px;
        .icon_sprite{
            background-position: -4px -3211px;
            height: 28px;
            width: 27px;
            background: url('https://vatgia.com/css/v4/beacon_sprite.png') no-repeat;
            display: inline-block;
            vertical-align: middle;
        }
         .note{
            font-size: 12px;
            color: #999;
            font-weight: normal;
            margin-top: 1px;
        }
    }
    .search_input{
        .box-size-color{
            display : flex;
            .name{
                width: max-content;
                padding: 5px;
                float: left;
                background: #20c997;
                margin-right: 5px;
                border-radius: 5px;
                color: #fff;
                margin-bottom: 5px;
                cursor: pointer;
                span{
                    margin-left: 3px;
                }
            }
        }
        .sizeColor{
            border: 1px solid #ccc;
            border-radius: 3px;
            height: 100px;
            color: #ccc;
            font-size: 13px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .search{
            width: 372px;
            &.mobile-search{
                width: 317px!important;
                .add_keyword_estore{
                    padding: 0;
                    line-height: 35px;
                    margin-left: 7px;
                    width: 35px;
                    left: unset;
                }
            }
            .add_keyword_estore{
                background: #1786cd;
                color: white;
                font-size: 13px;
                padding: 7px 10px;
                border-radius: 4px;
                cursor: pointer;
                text-align: center;
                position: absolute;
                top: 3px;
                height: 35px;
                left: 390px;
                width: 105px;
                position: absolute;
                top: 0;
            }
        }
    }
    .search_input_suggest{
        span{
            cursor: pointer;
            background: #eaf3f8;
            color: #a5b9c2;
            font-size: 12px;
            border: 1px solid #a5b9c2;
            padding: 0 10px;
            display: inline-block;
            margin-right: 10px;
            height: 25px;
            line-height: 25px;
            border-radius: 3px;
            box-sizing: border-box;
            margin-bottom: 5px;
            &.active{
                color: white;
                background: #1786cd;
                border-color: #1786cd;
            }
        }
    }
    .hit-rv{
        select{
            height: 35px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #606266;
            outline: none;
            cursor: pointer;
            width: 75px;
            option{
                width: 75px;
            }
        }
    }
    .box-suggest{
        &.box-suggest-mobile{
            width : 317px!important;
        }
        width: 372px;
        border-right: 1px solid #d7d7d7;
        border-left: 1px solid #d7d7d7;
        background: white;
        box-sizing: border-box;
        z-index : 12;
        li{
            border-bottom: 1px solid #d7d7d7;
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            cursor: pointer;
            .price-k{
                font-size: 13px;
                float : right;
                .price{
                    color: #f44f00;
                }
            }
        }
    }
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to{
        transform: translateX(10px);
        opacity: 0;
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .search_input{
            .search{
                &.mobile-search {
                    width: 265px !important;
                }
            }
        }
        .table-mobile .end-start {
            line-height: 130%!important;
            justify-content: center;
            align-items: center;
            display: flex;
        }
    }
</style>
